import { GetFunTree, GetFunList, GetFunNameList } from '@/api/common'

let funSelect = {
  data() {
    return {
      funSelect: {
        text: '',
        visible: false,
        checked: [],
        halfChecked: [],
        data: [],
        loading: false,
        props: {
          value: 'value',
          label: 'label',
          children: 'child',
          disabled: 'disabled',
          isLeaf: 'isLeaf'
        }
      }
    }
  },
  methods: {
    funSelectHalfCheck(rows) {
      this.funSelect.halfChecked = rows.slice()
    },
    funSelectCheck(rows) {
      this.funSelect.checked = rows
      this.funSelect.text = rows.map(k => k.label).join(',')
    },
    funSelectSetChecked(UserID) {
      if (!UserID) {
        this.funSelect.checked = []
        this.funSelect.text = ''
        return
      }

      this.funSelect.loading = true
      GetFunNameList(UserID).then(ret => {
        this.funSelect.checked = ret.data.slice().map(i => {
          return {
            value: i.FunID
          }
        })
        this.funSelect.text = ret.data.slice().map(i=>i.FunName).join(',')
        this.funSelect.loading = false
      }).catch(err => {
        this.funSelect.loading = false
      })
    }
  },
  components: {

  },
  created() {
    // 获取数据
    this.funSelect.loading = true
    if (this.funSelect.data.length == 0) {
      GetFunTree(-1).then(ret => {

        this.funSelect.data = ret.data.slice()
        this.funSelect.loading = false
      }).catch(err => {

        this.funSelect.loading = false
      })
    }
  },
  mounted() {
  }
}

export default funSelect



// WEBPACK FOOTER //
// ./src/views/mixins/fun-select.js